/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'eye': {
    width: 16,
    height: 11,
    viewBox: '0 0 16 11',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M1.125 5.014l.893-1.192a7.75 7.75 0 0111.964 0l.893 1.192-.893 1.19a7.75 7.75 0 01-11.964 0l-.893-1.19zM0 5.014c0-.105.032-.21.1-.3l1.125-1.5a8.75 8.75 0 0113.55 0l1.125 1.5a.498.498 0 010 .6l-1.125 1.5a8.75 8.75 0 01-13.55 0L.1 5.314a.498.498 0 01-.1-.3zm8-1a1 1 0 100 2 1 1 0 000-2zm-2 1a2 2 0 114 0 2 2 0 01-4 0z" _fill="#1F222C"/>'
  }
})
